module.exports = __webpack_public_path__ + "assets/img/img6.16df92ae.png";